import Index from './Index';
import AgentReports from './AgentReports';
import LabelReports from './LabelReports';
import InboxReports from './InboxReports';
import TeamReports from './TeamReports';
import CsatResponses from './CsatResponses';
import LiveReports from './LiveReports';
import ClosingReasonsReports from './ClosingReasonsReports';
import CampaignsReports from './CampaignsReports.vue';
import C2wCampaignsReports from './C2wCampaignsReports.vue';
import CallLogReports from './CallLogReports.vue';
import ApiErrorsReports from './ApiErrorsReports.vue';
import TemplateEventsReports from './TemplateEventsReports.vue';
import LabelsReports from './LabelsReports.vue';
import WhatsappConsumptionsReports from './WhatsappConsumptionsReports.vue';
import VirtualAssistantConsumptionsReports from './VirtualAssistantConsumptionsReports.vue';
import DashboardApps from '../../dashboard-apps/Index';
import SettingsContent from '../Wrapper';
import { frontendURL } from '../../../../helper/URLHelper';
import DashboardAppSuperset from './superset/DashboardApp';
import store from '../../../../store';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: () => {            
            if (store.getters.getCurrentTypeAccount === 'parent_account') {
              return frontendURL('accounts/:accountId/reports/attendances');
            }
            return frontendURL('accounts/:accountId/reports/overview');
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_REPORTS.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          path: 'csat',
          name: 'csat_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: CsatResponses,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent',
          name: 'agent_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: AgentReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: LabelReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: InboxReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: TeamReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'Atendimentos',
        icon: 'chat',
      },
      children: [
        {
          path: 'attendances',
          name: 'attendance_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardAppSuperset,
          props: {
            slug: 'attendances'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'Atendimentos detalhado',
        icon: 'mail-inbox-all',
      },
      children: [
        {
          path: 'attendance-details',
          name: 'attendance_detail_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardAppSuperset,
          props: {
            slug: 'attendance-details'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'Atendimento por agente',
        icon: 'people',
      },
      children: [
        {
          path: 'attendance-agents',
          name: 'attendance_agent_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardAppSuperset,
          props: {
            slug: 'attendance-agents'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.SCHEDULED_MESSAGES',
        icon: 'tag',
      },
      children: [
        {
          path: 'scheduled-messages',
          name: 'scheduled_messages_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardAppSuperset,
          props: {
            slug: 'scheduled-messages'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.HEADER',
        icon: 'megaphone',
        keepAlive: false,
      },
      children: [
        {
          path: 'campaigns',
          name: 'campaigns_reports',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardAppSuperset,
          props: {
            slug: 'campaigns'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'DASHBOARD_APPS.HEADER',
        icon: 'automation',
      },
      children: [
        {
          path: 'dashboard-apps',
          name: 'reports_dashboard_apps',
          roles: ['administrator', 'supervisor', 'analyzer', 'assistant'],
          component: DashboardApps,
          accountTypes: ['account', 'subaccount', 'parent_account']
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CLOSING_REASONS.HEADER',
        icon: 'lock-closed',
      },
      children: [
        {
          path: 'closing-reasons',
          name: 'closing_reason_reports',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: ClosingReasonsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGNS_REPORT.HEADER',
        icon: 'megaphone',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-campaigns',
          name: 'campaigns_reports_api',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: CampaignsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'C2W_CAMPAIGNS_REPORT.HEADER',
        icon: 'whatsapp',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-c2w-campaigns',
          name: 'c2w_campaigns_reports_api',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: C2wCampaignsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CALL_LOG_REPORT.HEADER',
        icon: 'phone',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-call-logs',
          name: 'call_log_reports_api',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: CallLogReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'API_ERRORS_REPORT.HEADER',
        icon: 'error-circle',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-api-errors',
          name: 'api_errors_reports',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: ApiErrorsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEMPLATE_EVENTS_REPORT.HEADER',
        icon: 'template',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-template-events',
          name: 'history_template_events',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: TemplateEventsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABELS_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'labels',
          name: 'labels_reports',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: LabelsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'WHATSAPP_CONSUMPTIONS_REPORT.HEADER',
        icon: 'receipt',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-whatsapp-consumptions',
          name: 'history_whatsapp_consumptions',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: () => {
            return store.getters.getCurrentTypeAccount === 'parent_account'
              ? Promise.resolve(DashboardAppSuperset)
              : Promise.resolve(WhatsappConsumptionsReports)
          },
          props: {
            slug: 'history-whatsapp-consumptions'
          },
          accountTypes: ['account', 'subaccount', 'parent_account']
        },        
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.HEADER',
        icon: 'robot',
        keepAlive: false,
      },
      children: [
        {
          path: 'history-virtual-assistant-consumptions',
          name: 'history_virtual_assistant_consumptions',
          roles: ['administrator', 'analyzer', 'supervisor'],
          component: VirtualAssistantConsumptionsReports,
        },
      ],
    },
  ],
};
